"use strict";

var elementCtrl = [
  "graphDataFactory",
  "$scope",
  "$timeout",
  "$rootScope",
  function (graphDataFactory, $scope, $timeout, $rootScope) {
    var _this = this;
    _this.expanded = false;
    $scope.displayValueSelected = "";
    _this.selected = [];
    $scope.updateValue = function () {
      _this.onChange(_this.element);
    };

    // Reconstruye el texto visible desde el valor persistente del filtro.
    // Necesario porque al cambiar de página la directiva se recrea y
    // displayValueSelected (estado de scope) se perdería aunque element.value siga seteado.
    _this.refreshDisplayValue = () => {
      if (["multiple", "select"].includes(_this.element.type))
        $scope.displayValueSelected = (_this.element.value || []).map((sel) => {
          let stringSel = String(sel);
          return stringSel.substring(stringSel.indexOf("|") + 1, 100);
        });
      else $scope.displayValueSelected = _this.element.value;
    };

    function loadOptions() {
      return graphDataFactory.getData(_this.element.id).then(function (data) {
        _this.optionsList = data;
        return data;
      });
    }

    _this.reloadOptions = () => {
        // console.log('RELOAD OPTIONS', _this.element)
        return graphDataFactory.getData(_this.element.id, true)
            .then(function (data) {
                if (!Array.isArray(data)) return data;
                _this.optionsList = data;
                return data;
            });
    }

    _this.titleOption = (option) => {
        // console.log('titleOption', option, _this.element.type)
      try{
        let optionString = String(option);
        return (option == undefined || (option.id == undefined && option._id == undefined)) ?
            (["multiple", "select"].includes(_this.element.type) ? optionString.substring(optionString.indexOf("|") + 1, 100) : optionString) :
            ("".concat(option.lastName, " ", option.firstName, " ", option.email));
      }catch(e){
        return "";
      }
    };

    _this.open = () => {
      _this.selected = JSON.parse(JSON.stringify(_this.element.value || []));
      _this.expanded = !_this.expanded;

      // Al expandir, enfocar el buscador (esperar a que el DOM lo renderice).
      if (_this.expanded)
        $timeout(function () {
          let searchInput = document.getElementById(_this.element.id + "_search");
          if (searchInput) searchInput.focus();
        });
    };

    _this.close = () => {
      _this.selected = [];
      _this.expanded = !_this.expanded;
    };

    _this.apply = () => {
        _this.element.value = JSON.parse(JSON.stringify(_this.selected));
        _this.refreshDisplayValue();
        _this.expanded = false;
        _this.selected = [];
        _this.onChange(_this.element);
    };

    _this.cleanSelection = () => {
        // Clean previus selection
        _this.element.value = [];
        _this.selected = [];
        $scope.displayValueSelected = "";

        // Trigger apply to update the element and other components
        _this.apply();
    }
    _this.selectAll = () => {
        // Select all options
        _this.selected = _this.optionsList.map(option => option.id || option._id || option);
        _this.apply();
    }

    _this.toogleCheck = (option) => {
      let index = _this.selected.indexOf(option.id || option._id || option);
      if (index > -1) _this.selected.splice(index, 1);
      else _this.selected.push(option.id || option._id || option);
    };

    _this.isChecked = (option) => {
      if (_this.element.value == undefined || option == undefined) return false;
      let m = _this.element.value;
      return m.includes(option.id || option._id || option);
    };
    _this.optionsList = _this.element.templateData.optionsType == "static"
        ? _this.element.templateData.options
        : loadOptions();

    // Al crearse/recrearse la directiva, mostrar el filtro que ya esté aplicado.
    _this.refreshDisplayValue();

    $rootScope.$on("graph-select-filter", function (event, element) {
        // console.log('SELECT FILTER RECEIVED', element, _this.element)
        // BROADCAST ON, FIJARME SI ESTE FILTRO TIENE QUE ACTUAR EN ESTE ELEMENTO
        let matches = _this.element?.templateData?.datasource?.filters?.some(filter => {
            return filter.conditions?.some(condition => condition.value === element.id);
        });
        if (matches) {
            // console.log('MATCHES _this.element', _this.element)
            _this.optionsList = _this.element.templateData.optionsType == "static" ? _this.element.templateData.options : _this.reloadOptions();
        }
    });
  },
];

module.exports = function () {
  return {
    restrict: "E",
    scope: {
      element: "=",
      onChange: "&",
    },
    replace: true,
    controller: elementCtrl,
    controllerAs: "ctrl",
    bindToController: true,
    templateUrl: "dashboard-graph-view/graphSelectViewDirective.html",
  };
};